import { Loader2 } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { OPS } from "@/constants/testIds";

export const FullScreenLoader = () => {
    const { t } = useI18n();
    return (
        <div
            data-testid={OPS.error.loading}
            className="min-h-screen w-full flex flex-col items-center justify-center gap-3 bg-[color:var(--bg-app)]"
        >
            <Loader2 className="h-7 w-7 animate-spin text-[color:var(--brand-orange)]" />
            <p className="text-sm text-[color:var(--ink-muted)]">{t("loading")}</p>
        </div>
    );
};

export const InlineLoader = ({ label }) => (
    <div className="flex items-center justify-center gap-2 py-10 text-[color:var(--ink-muted)]">
        <Loader2 className="h-5 w-5 animate-spin" />
        {label ? <span className="text-sm">{label}</span> : null}
    </div>
);
